import { RepositoryFactory } from "../../Apicall/RepositoryFactory"
const Errorcodes= RepositoryFactory.get("errorcodes")
export default {
  getErrorCodes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await Errorcodes.getErrorCodes(
              payload
        )

        commit("ERROR_CODES", {
          key: "errorcodes",
          value: data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  addErrorCodes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await Errorcodes.addErrorCodes(
              payload
        )
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editErrorCodes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await Errorcodes.editErrorCodes(
              payload
        )
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  removeErrorCodes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await Errorcodes.removeErrorCodes(
              payload
        )
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};